import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

interface LegendItem {
  color: string;
  label: string;
  icon?: string;
  tooltip?: string;
}

@Component({
  selector: 'app-dashboard-infos',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatTooltipModule],
  templateUrl: './dashboard-infos.component.html',
  styleUrl: './dashboard-infos.component.css',
})
export class DashboardInfosComponent {
  displayedColumns: string[] = ['color', 'label'];

  legendItems: LegendItem[] = [
    {
      color: '#8fdc6f',
      label: 'Commercial et Technique OK',
      tooltip: 'Succès',
    },
    {
      color: '#b0f193',
      label: ' Commercial et Technique OK, Régularisation de la facturation à prévoir au renouvellement',
      tooltip: 'Succès',
    },
    {
      color: 'orange',
      label: 'Commercial OK mais poste ou serveur présent dans RG non présent dans BIT, ou inversement',
      tooltip: 'Attention',
    },
    {
      color: '#f65c5c',
      label: "Technique OK ; Erreur Commerciale",
      tooltip: 'Erreur',
    },
    {
      color: '#b90000',
      label: "Erreurs technique ET commerciale",
      tooltip: 'Erreur',
    },
    {
      color: '#2196F3',
      label: 'Pas de contrat BIT',
      tooltip: 'Information',
    },
    {
      color: '#1976d2',
      label: 'Un ou plusieurs incidents affranchis liés à ce client',
      icon: 'report_off',
    },
  ];
}
